import { toRefs, ref, onMounted } from 'vue';
import { useVideoWatchTracking } from './component-lib.esm27.js';
import { useVimeoApi } from '../../compositions/component-lib.esm2.js';
import { useMounted } from '../../compositions/component-lib.esm4.js';
import { defaultWindow } from '../../utils/component-lib.esm5.js';
import { EVENTS } from '../../config/component-lib.esm.js';

//
var script = {
  props: {
    id: {
      type: String,
      required: true
    },
    trackVideoPlayEvents: Boolean
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      trackVideoPlayEvents
    } = toRefs(props);
    const player = ref(null);
    const videoStarted = ref(false);
    const window = defaultWindow;
    const isMounted = useMounted();
    const playerRef = ref(null);
    const {
      track,
      stop
    } = useVideoWatchTracking(event => emit('event', event), {
      // Vimeo methods return promises
      getDuration: () => player.value.getDuration(),
      getCurrentTime: () => player.value.getCurrentTime(),
      trackPlaying: trackVideoPlayEvents.value
    });
    function loadVideo() {
      if (!isMounted.value) return;
      player.value = new Vimeo.Player(playerRef.value);
      subscribe();
    }
    function subscribe() {
      player.value.on('play', () => {
        if (!videoStarted.value) emit('event', EVENTS.VIDEO_STARTED);
        if (!trackVideoPlayEvents.value) emit('event', EVENTS.VIDEO_PLAYING);
        videoStarted.value = true;
        track();
      });
      player.value.on('pause', () => {
        emit('event', EVENTS.VIDEO_PAUSED);
        stop();
      });
      player.value.on('ended', () => {
        emit('event', EVENTS.VIDEO_ENDED);
        stop();
      });
    }
    useVimeoApi(loadVideo);
    onMounted(() => {
      if (window && window.Vimeo) loadVideo(window.Vimeo);
    });
    return {
      playerRef
    };
  }
};
export { script as default };